import { render, staticRenderFns } from "./LotViewPrevNextButtons.vue?vue&type=template&id=851459de&scoped=true"
import script from "./LotViewPrevNextButtons.vue?vue&type=script&lang=js"
export * from "./LotViewPrevNextButtons.vue?vue&type=script&lang=js"
import style0 from "./LotViewPrevNextButtons.vue?vue&type=style&index=0&id=851459de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851459de",
  null
  
)

export default component.exports